import { Platform } from 'react-native';

/**
 * Spread onto a `<TextInput>` whose text is deliberately LARGER than 16px.
 *
 * public/index.html floors every input and textarea at 16px on touch screens,
 * because iOS zooms the page when a smaller field is focused and never zooms
 * back out (#723). CSS cannot take the larger of 16px and a field's own size,
 * so the floor is a flat `16px !important` — and a 22px title field would be
 * shrunk to 16px on a phone. This attribute is how such a field opts out.
 *
 * Fields at 16px or below never need it, and must not use it: opting out puts
 * the zoom back. scripts/__tests__/inputZoomFloor.test.ts fails on any
 * TextInput styled above 16px without it.
 *
 * `dataSet` is how react-native-web renders `data-*`; it drops a bare
 * `data-font-floor` prop. Web only, so native never sees an unknown prop.
 */
export const aboveFontFloor: object =
  Platform.OS === 'web' ? { dataSet: { fontFloor: 'exempt' } } : {};
